/**
 * theme.js
 * JavaScript extracted from theme.liquid
 */

(function() {
  'use strict';

  /**
   * Cart Details Toggle Handler
   * Shows/hides custom cart item properties
   */
  function initCartDetailsToggle() {
    setInterval(function() {
      document.querySelectorAll('.show_details').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const details = this.nextElementSibling;
          if (details && details.classList.contains('cart-items__properties_ctm')) {
            details.style.display = 'block';
            this.style.display = 'none';
          }
        });
      });

      document.querySelectorAll('.hide_details').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const details = this.closest('.cart-items__properties_ctm');
          if (details) {
            details.style.display = 'none';
            const showBtn = details.previousElementSibling;
            if (showBtn && showBtn.classList.contains('show_details')) {
              showBtn.style.display = 'block';
            }
          }
        });
      });
    }, 1000);

    // Discount banner close handler
    const discountCloseLink = document.querySelector('.korting_email_section a.size-style');
    if (discountCloseLink) {
      discountCloseLink.addEventListener('click', function() {
        this.closest('.korting_email_section').style.display = 'none';
      });
    }
  }

  /**
   * Dynamic Kleur/Farbe (Color) Visibility
   * Hides/shows color options based on Material selection
   */
  function updateKleurVisibility() {
    const countryISO = window.countryISO || 'NL';
    let firstSelector, secondSelector, option1_name, option2_name;

    if (countryISO === 'DE') {
      firstSelector = 'Material';
      secondSelector = 'Farbe';
      option1_name = 'Papier';
      option2_name = 'Poster gerahmt';
    } else {
      firstSelector = 'Materiaal';
      secondSelector = 'Kleur';
      option1_name = 'Papier';
      option2_name = 'Poster ingelijst';
    }

    const selectedMateriaal = document.querySelector(
      `.variant-option--buttons input[type="radio"][name^="${firstSelector}"]:checked`
    )?.value;

    const kleurFieldset = Array.from(document.querySelectorAll('fieldset')).find(fieldset =>
      fieldset.querySelector('legend')?.textContent.trim() === secondSelector
    );

    if (!kleurFieldset) return;

    if (selectedMateriaal === option1_name) {
      kleurFieldset.classList.add('hide-kleur');
    } else {
      kleurFieldset.classList.remove('hide-kleur');
    }

    const kleurOptions = kleurFieldset.querySelectorAll('.variant-option__button-label');

    kleurOptions.forEach(optionLabel => {
      const input = optionLabel.querySelector('input[type="radio"]');
      if (selectedMateriaal === option2_name && input?.dataset.optionAvailable === 'false') {
        optionLabel.style.display = 'none';
      } else {
        optionLabel.style.display = '';
      }
    });

    const checkedKleurInput = kleurFieldset.querySelector('input[type="radio"]:checked');

    if (checkedKleurInput?.getAttribute('aria-disabled') === 'true') {
      const firstAvailable = kleurFieldset.querySelector('input[type="radio"][data-option-available="true"]');
      if (firstAvailable) {
        firstAvailable.checked = true;
        firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function initKleurVisibility() {
    updateKleurVisibility();

    document.querySelectorAll('.variant-option--buttons input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', updateKleurVisibility);
    });

    setInterval(updateKleurVisibility, 200);
  }

  /**
   * Mobile Modals Close Handler
   * Closes cart drawer when modals are opened on mobile
   */
  function initMobileModalsHandler() {
    if (typeof jQuery === 'undefined') return;

    jQuery('#LocalizationForm input[name="return_to"]').val('/');

    jQuery(document).ready(function() {
      function checkAndTrigger() {
        const $modalsContainer = jQuery("#modals-container");
        const $closeButton = jQuery(".cart-drawer__close-button");
        const isMobile = window.matchMedia("(max-width: 768px)");

        if ($modalsContainer.children().length > 0 && isMobile.matches) {
          $closeButton.trigger("click");
        }
      }
      setInterval(checkAndTrigger, 1000);
    });
  }

  /**
   * TeeInBlue Option Label Cleanup
   * Removes text after "^" in field labels
   */
  function initTeeInBlueLabelCleanup() {
    function processOptionLabels() {
      const selectors = [
        '.tee-field__heading',
        '.tee-field__label',
        '.tee-option-label',
        '#teeFormInputs label',
        '#teeFormInputs .tee-field__heading-label'
      ];

      selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(element => {
          const text = element.textContent;
          if (text && text.includes('^')) {
            const cleanText = text.split('^')[0];
            if (element.textContent !== cleanText) {
              element.textContent = cleanText;
            }
          }
        });
      });
    }

    setTimeout(processOptionLabels, 500);

    const targetNode = document.getElementById('teeFormInputs');
    if (targetNode) {
      const observer = new MutationObserver(function() {
        processOptionLabels();
      });

      observer.observe(targetNode, {
        childList: true,
        subtree: true
      });
    }

    setInterval(processOptionLabels, 1000);
  }

  /**
   * Free Jewelry Price Toggle
   * Shows/hides free jewelry prices based on cart total
   */
  function initFreeJewelryPriceToggle() {
    const config = window.freeJewelryConfig;
    if (!config || !config.threshold) return;

    const threshold = config.threshold;

    function toggleFreePrices() {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const thresholdReached = (cart.total_price / 100) >= threshold;
          const hasFreeJewelryInCart = cart.items.some(item =>
            item.properties && item.properties._free_gift === 'true'
          );
          const showFree = thresholdReached && !hasFreeJewelryInCart;

          document.querySelectorAll('[data-free-jewelry="true"]').forEach(container => {
            const normalPrices = container.querySelectorAll('.price-normal, .compare-at-price:not(.compare-at-price-free)');
            const freePrices = container.querySelectorAll('.price-free, .compare-at-price-free');

            normalPrices.forEach(el => el.style.display = showFree ? 'none' : '');
            freePrices.forEach(el => el.style.display = showFree ? '' : 'none');
          });
        })
        .catch(() => {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', toggleFreePrices);
    } else {
      toggleFreePrices();
    }

    document.addEventListener('cart:updated', toggleFreePrices);
    document.addEventListener('cart:update', toggleFreePrices);
  }

  // Initialize all handlers on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    initCartDetailsToggle();
    initKleurVisibility();
    initMobileModalsHandler();
    initTeeInBlueLabelCleanup();
    initFreeJewelryPriceToggle();
  });

  // Export for external use
  window.PivvyTheme = window.PivvyTheme || {};
  window.PivvyTheme.updateKleurVisibility = updateKleurVisibility;
})();
